import React from "react"

import SourceTab from "./source-tab"

function TabSkeleton() {
  return (
    <div className="flex items-center px-3 py-2 w-full border border-transparent">
      <div className="flex justify-center items-center w-8 h-8 mr-3">
        <div
          className="w-full h-full animate-pulse"
          style={{
            background:
              "linear-gradient(180deg, var(--gray-200) 0%, var(--gray-50) 100%)",
            borderRadius: "4px"
          }}
        />
      </div>
      <div
        className="h-4 w-24 animate-pulse"
        style={{
          background:
            "linear-gradient(180deg, var(--gray-200) 0%, var(--gray-50) 100%)",
          borderRadius: "4px"
        }}
      />
    </div>
  )
}

export default function PluginTabs({
  activeTab,
  setActiveTab,
  hasError,
  isLoading,
  plugins
}) {
  if (hasError) return null

  if (isLoading) {
    return (
      <>
        <TabSkeleton />
        <TabSkeleton />
      </>
    )
  }

  return (
    <>
      {plugins?.map(plugin => (
        <SourceTab
          key={plugin.id}
          icon={
            <img
              src={plugin.icon_url}
              alt={""}
              className="border border-gray-200 p-1 rounded-sm w-8 h-8 object-cover"
            />
          }
          title={plugin.label}
          active={activeTab === plugin.id}
          onClick={() => setActiveTab(plugin.id)}
        />
      ))}
    </>
  )
}
